import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { Settings } from "../../../styles/theme"

const PartnerDescriptionStyled = styled.div`
  position: relative;
  .col {
    padding: 1rem;
    margin: 1rem;
    cursor: pointer;
    .wrapper {
      border: ${props =>
        props.selected ? "2px solid " + "rgba(0,0,0,0.2)" : "none"};
      position: relative;
      max-width: 150px !important;
      padding: 1rem;
      margin: 0 auto;
    }
  }
  h6 {
    text-align: center;
    font-weight: 300;
    font-size: 1.2rem;
  }
`

export const PartnerDescription = ({
  partner,
  selected,
  objectId,
  callback,
}) => (
  <PartnerDescriptionStyled
    selected={selected === objectId ? true : false}
    onClick={() => callback(objectId)}
  >
    <div className="col">
      <div className="wrapper">
        {partner.slug ? (
          <a href={partner.slug} target="_blank">
            <Img fluid={partner.image.fluid} />
          </a>
        ) : (
          <Img fluid={partner.image.fluid} />
        )}
        {partner.description ? <h6>{partner.description}</h6> : ""}
      </div>
    </div>
  </PartnerDescriptionStyled>
)

const PartnerTextStyled = styled.div`
  position: relative;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${Settings.primaryColor};
  }
  border-top: 1px solid rgba(88, 88, 88, 0.3);
  border-bottom: 1px solid rgba(88, 88, 88, 0.3);
  margin: 1rem 0;
  h4 {
    font-weight: 700;
  }
`

export const PartnerText = ({ text, title }) => (
  <PartnerTextStyled>
    <h4>{title}</h4>
    {documentToReactComponents(text)}
  </PartnerTextStyled>
)

const NoDescriptionStyle = styled.div`
  .col {
    cursor: auto !important;
  }
`

export const PartnerNoDescription = ({ partner }) => (
  <NoDescriptionStyle>
    <PartnerDescriptionStyled>
      <div className="col">
        {partner.slug ? (
          <a href={partner.slug} target="_blank">
            {console.log(partner)}
            <Img fluid={partner.image.fluid} />
          </a>
        ) : (
          <Img fluid={partner.image.fluid} />
        )}
      </div>
    </PartnerDescriptionStyled>
  </NoDescriptionStyle>
)
